import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@material-ui/core';
import { EntityAuditTooltip } from 'components/EntityAudit/EntityAuditTooltip';
import NotificationProvider from 'components/NotificationProvider';
import { selectIsClient } from 'features/user/userSlice';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NoteContent } from './NoteContent';
import { useAddNoteMutation, useEditNoteMutation } from './notesSlice';

const NoteEditor = ({
    note,
    onClose,
    withDialog = true,
    hideViewByClient
}) => {
    const isClient = useSelector(selectIsClient);
    const [changed, setChanged] = useState(false);
    const [saving, setSaving] = useState(false);
    const [noteToEdit, setNoteToEdit] = useState({ viewByClient: isClient ? true : false });
    const [addNote] = useAddNoteMutation();
    const [saveNote] = useEditNoteMutation();

    useEffect(() => {
        setNoteToEdit({ ...noteToEdit, ...note });
    }, [note]);

    const onChange = (field, value) => {
        setNoteToEdit({ ...noteToEdit, [field]: value });
    }

    const onSave = async () => {
        setSaving(true);
        let res;
        noteToEdit.showInReport = !noteToEdit.viewByClient ? false : noteToEdit.showInReport;
        if (noteToEdit.id) {
            res = await saveNote(noteToEdit);
        } else {
            res = await addNote(noteToEdit);
        }
        if (res.error) {
            NotificationProvider.error('Failed to save the note');
        } else {
            NotificationProvider.success('Successfully save the note');
            onClose();
        }
        setSaving(false)
    }
    const noteContent = <NoteContent
        content={noteToEdit.content}
        viewByClient={noteToEdit?.viewByClient}
        onChange={onChange}
        showInReport={noteToEdit?.showInReport}
        entityType={noteToEdit.entityType}
        hideViewByClient={hideViewByClient}
    />

    const buttons = <><Button onClick={() => onClose()} >
        Cancel
    </Button>
        <Button disabled={saving} onClick={onSave} variant="contained" color='primary'>
            {saving ? 'Saving...' : 'Save'}
        </Button></>

    return (
        <> {withDialog ?
            <Dialog open={true} onClose={onClose}>
                <DialogTitle>
                    {note?.id ? 'Edit Note' : 'Add Note'}
                    {note?.id && <EntityAuditTooltip entity={note} />}
                </DialogTitle>
                <DialogContent>
                    {noteContent}
                </DialogContent>
                <DialogActions>
                    {buttons}
                </DialogActions>
            </Dialog>
            : <Grid container direction='column'>
                <Grid item>
                    {noteContent}
                </Grid>
                <Grid container style={{ justifyContent: 'end' }}>
                    {buttons}
                </Grid>
            </Grid>
        } </>
    );
}
export default NoteEditor;
